import { render, staticRenderFns } from "./Slots.vue?vue&type=template&id=524cb298&scoped=true&"
import script from "./Slots.vue?vue&type=script&lang=js&"
export * from "./Slots.vue?vue&type=script&lang=js&"
import style0 from "./Slots.vue?vue&type=style&index=0&id=524cb298&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524cb298",
  null
  
)

export default component.exports